"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_GRID_SIZES = exports.MENU_ID = exports.STANDARD_MENU = void 0;
const models_1 = require("../models");
exports.STANDARD_MENU = 'Standard Menu';
exports.MENU_ID = 'MENU_ID';
exports.DEFAULT_GRID_SIZES = {
    [models_1.GridType.PRODUCTS]: {
        rows: 5,
        columns: 5,
    },
    [models_1.GridType.OPTIONS]: {
        columns: 5,
        rows: 3,
    },
};
//# sourceMappingURL=menus.js.map